export const enum CdiPaymentStatus {
  Unknown = 'Unknown',
  Created = 'Created',
  Processing = 'Processing',
  Error = 'Error',
  HttpError = 'HttpError',
  PaymentDeclined = 'PaymentDeclined',
  PartialPayment = 'PartialPayment',
  PaymentSuccessful = 'PaymentSuccessful',
  PaymentComplete = 'PaymentComplete',
}
